import { mapComponentThemes } from "../themes";
import { choiceTheme, choiceGroupTheme } from "../Choice"; // $FlowFixMe - strict theme keys incompatible with mapComponentThemes

export var checkboxTheme = function checkboxTheme(baseTheme) {
  return mapComponentThemes({
    name: 'Choice',
    theme: choiceTheme(baseTheme)
  }, {
    name: 'Checkbox',
    theme: {}
  }, baseTheme);
}; // $FlowFixMe - strict theme keys incompatible with mapComponentThemes

export var checkboxGroupTheme = function checkboxGroupTheme(baseTheme) {
  return mapComponentThemes({
    name: 'ChoiceGroup',
    theme: choiceGroupTheme(baseTheme)
  }, {
    name: 'CheckboxGroup',
    theme: {}
  }, baseTheme);
};